var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HistoryList } from './HistoryList/HistoryList';
import { HistoryFilters } from './HistoryFilters/HistoryFilters';
import styles from './history.module.scss';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { E_ICONS } from 'src/ui/components/Icons/constants';
export var History = function (props) {
    var i18n = props.i18n, applicants = props.applicants, history = props.history, allFiltersHistory = props.allFiltersHistory, currentFiltersHistory = props.currentFiltersHistory, dynamicsConfig = props.dynamicsConfig, host = props.host, updateHistoryFilters = props.updateHistoryFilters, resetHistoryFilters = props.resetHistoryFilters;
    var noElementLabel = getPropsByKeyPath(i18n, 'modules.timeline.noElementLabel');
    var resetFiltersLabel = getPropsByKeyPath(i18n, 'modules.timeline.resetFiltersLabel');
    return (_jsxs("section", __assign({ className: styles.historyWrapper }, { children: [_jsx(HistoryFilters, { i18n: i18n, allFiltersHistory: allFiltersHistory, currentFilters: currentFiltersHistory, onFiltersChange: updateHistoryFilters }), history.length > 0 ? (_jsx(HistoryList, { host: host, i18n: i18n, history: history, applicants: applicants, dynamicsConfig: dynamicsConfig })) : (_jsxs("div", __assign({ className: styles.placeholderWrapper }, { children: [_jsx("p", { children: noElementLabel }), _jsx(Button, { type: EButtonType.NEUTRAL, label: resetFiltersLabel, classname: styles.button, leftIcon: E_ICONS.ROLLBACK, onClick: resetHistoryFilters })] })))] })));
};
